<template>
  <div>
    <v-navigation-drawer
      v-model="drawerModel"
      app
      temporary
      width="400"
      right
    >
      <v-img
        height="100%"
        style="background-image: linear-gradient(rgba(29, 19, 19, 0.50), rgba(29, 19, 19, 0.50)), url(/img/user_background.jpg)"
      >
        <v-container class="dark">
          <v-col
            align-self="center"
            justify-self="center"
          >
            <v-list>
              <v-list-item>
                <v-skeleton-loader
                  :loading="loading"
                  type="avatar"
                  class="mx-auto d-block"
                >
                  <v-list-item-avatar
                    class="mx-auto d-block"
                    size="120"
                  >
                    <viewer 
                      ref="viewer"
                      :images="images"   
                      :options="options" 
                      @inited="imageViewerInited"
                    >
                      <template slot-scope="scope">
                        <img 
                          v-for="src in scope.images"
                          v-show="false"             
                          :key="src" 
                          :src="src"
                        >
                      </template>
                    </viewer>
                  
                    <!-- <div
                    v-viewer="options" 
                    :images="images">
                    <img
                      :src="user_thumbnail">    
                  </div> -->
                    <img
                      :src="employee.thumbnail_url"
                      @click="showViewer"
                    >
                  </v-list-item-avatar>
                </v-skeleton-loader>
              </v-list-item>
            </v-list> 
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-skeleton-loader
                      :loading="loading"
                      type="text"
                      class="mx-auto"
                    >
                      <h4
                        style="max-width: 300px;"
                        class="text-truncate text-center white--text font-weight-medium mb-0"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              :color="getStatusColor(employee)"
                              size="15" 
                              class="mb-1"
                              dark 
                              v-on="on"
                            >
                              fiber_manual_record
                            </v-icon>
                          </template>
                          <div v-if="employee.is_active_employment">
                            <span 
                              class="pl-6 ml-2 green--text"
                            > Active </span>
                          </div>
                          <div v-else>
                            <span 
                              v-if="isPending(employee)" 
                              class="pl-6 ml-1 warning--text"
                            > Pending </span>
                            <span 
                              v-else 
                              class="pl-4 ml-2 info--text"
                            > On Leave </span>
                          </div>
                        </v-tooltip>
                        {{ userName }}
                      </h4>
                    </v-skeleton-loader>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="baseLocation"
                class="mt-0 minimise-gap"
              >
                <v-list-item-content class="pt-0">
                  <v-list-item-title>
                    <v-skeleton-loader
                      :loading="loading"
                      type="text"
                      class="mx-auto"
                    >
                      <h5 class="text-center mt-0 mb-0 text-gray location-font">
                        <i>
                          {{ baseLocation }}
                        </i>
                      </h5>
                    </v-skeleton-loader>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="departmentName">
                <v-list-item-title>
                  <v-skeleton-loader
                    :loading="loading"
                    type="text"
                    class="mx-auto"
                  >
                    <h5 class="text-center body-2 white--text mt-0 mb-0 department-font">
                      {{ departmentName }}
                    </h5>
                  </v-skeleton-loader>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="position.name"
                class="mt-0 minimise-gap"
              >
                <v-list-item-title>
                  <v-skeleton-loader
                    :loading="loading"
                    type="text"
                    class="mx-auto"
                  >
                    <v-row class="align-center justify-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }"> 
                          <img
                            v-if="position.icon"
                            class="rank-icon ml-2 mr-2"
                            :src="position.icon "
                            v-on="on"
                          >
                        </template>
                      </v-tooltip>
                      <span
                        class="amber--text text--darken-1 position-name-wrap"
                      >
                        {{ position.name }} 
                      </span>
                    </v-row>
                  </v-skeleton-loader>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>
          <v-divider
            color="white"
          />

          <v-card 
            v-show="noOfSkills > 0" 
            class="mt-4 py-2"
            color="#CFD8DC"
          >
            <v-skeleton-loader
              :loading="loading"
              type="image"
              class="mx-auto"
            >
              <h4 class="text-center font-weight-bold mb-1">
                Skills Set
              </h4>
              <v-row>
                <v-col
                  v-for="(employeeSkill, index) in filteredSkills"
                  :key="index" 
                  lg="3"
                >
                  <v-list-item>
                    <v-list-item-avatar
                      tile
                    >
                      <v-tooltip 
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <img 
                            :src="employeeSkill.skill.image_url"
                            v-on="on"
                          >
                        </template>
                        <span 
                          class="font-weight-bold" 
                          v-text="employeeSkill.skill.name"
                        />
                        <v-rating
                          :value="employeeSkill.skill_level.level"
                          :length="employeeSkill.skill.levels.length"
                          readonly
                          small
                        />
                        <span> {{ employeeSkill.skill_level.description }}</span>
                      </v-tooltip>  
                    </v-list-item-avatar>
                  </v-list-item>
                </v-col>
              </v-row>
              <div 
                v-if="noOfSkills >= 5" 
                class="text-center headline font-weight-medium"
              >
                <a 
                  v-if="filterSkill"
                  @click.stop="filterSkill = false"
                >...</a> 
                <a 
                  v-else 
                  @click.stop="filterSkill = true"
                >...</a>
              </div>
            </v-skeleton-loader>
          </v-card>
         
          <v-card 
            v-show="noOfAwards > 0" 
            class="mt-4 py-2"
            color="#CFD8DC"
          >
            <v-skeleton-loader
              :loading="loading"
              type="image"
              class="mx-auto"
            >
              <h4 class="text-center font-weight-bold mb-1">
                Awards
              </h4>
              <v-row>
                <v-col
                  v-for="(employeeAward, index) in filteredAwards"
                  :key="index" 
                  lg="3"
                >
                  <v-list-item>
                    <v-list-item-avatar
                      tile
                    >
                      <v-tooltip 
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <img 
                            :src="employeeAward.award.image_url"
                            v-on="on"
                          >
                        </template>
                        <span 
                          class="font-weight-bold" 
                          v-text="employeeAward.award.name"
                        />
                      </v-tooltip>  
                    </v-list-item-avatar>
                  </v-list-item>
                </v-col>
              </v-row>
              <div 
                v-if="noOfAwards >= 5" 
                class="text-center headline font-weight-medium"
              >
                <a 
                  v-if="filterAward"
                  @click.stop="filterAward = false"
                >...</a> 
                <a 
                  v-else 
                  @click.stop="filterAward = true"
                >...</a>
              </div>
            </v-skeleton-loader>
          </v-card>
        </v-container>
      </v-img>
    </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    props: {
      departmentName: {
        type: String,
        default: null,
      },
      drawer: {
        type: Boolean,
        default: false,
      },
      userName: {
        type: String,
        default: null,
      },
      userPobId: {
        type: String,
        default: null,
      },
      employeeUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        loading: true,
        options: {
          toolbar: {
            zoomIn: 1,
            zoomOut: 1,
            reset: 1,
            play: {
              show: 1,
              size: 'large',
            },
          },
        },
        drawerModel: false,
        employeeSkills: [],
        employeeAwards: [],
        employee: {},
        filterAward: true,
        filterSkill: true,
        position: {
          name: '',
          rank: '',
          rankName: '',
          icon: '',
        },
        baseLocation: '',
        operators: {
          'asc': (levelA, levelB) => {
            return levelA - levelB 
          },
          'desc': (levelA, levelB) => {
            return levelB - levelA 
          },
        },
      }
    },  
    computed: {
      images () {
        return [ this.employee.avatar_url ]
      },
      filteredAwards () {
        if (this.noOfAwards < 5) return this.employeeAwards
        return this.filterAward ? this.employeeAwards.slice(0, 4) : this.employeeAwards
      },
      filteredSkills () {
        if (this.noOfSkills < 5) return this.sortedSkills

        return this.filterSkill ? this.sortedSkills.slice(0, 4) : this.sortedSkills
      },
      noOfAwards () {
        return this.employeeAwards.length
      },
      noOfSkills () {
        return this.employeeSkills.length
      },
      sortedSkills () {
        return [...this.employeeSkills]
          .sort((a, b) => this.operators['desc'](a.skill_level.level, b.skill_level.level))
          .sort((a, b) => this.operators['desc'](a.skill.levels.length, b.skill.levels.length))
      },
    },
    watch: {
      drawer (newValue, oldValue) {
        this.drawerModel = newValue
      },
      drawerModel (newValue, oldValue) {
        if (!newValue) {
          this.$resetData()
        }
        if (newValue !== oldValue) {
          this.$emit('changeDrawerStatus', newValue)
        }
      },
      employeeUid: {
        immediate: true,
        handler (newValue, oldValue) {
          if (this.drawerModel === true && newValue !== oldValue) {
            Promise.all([
              this.$api.employeeSkills().list(this.employeeUid),
              this.$api.employees().show(this.employeeUid),
              this.$api.employeeAwards().show(this.employeeUid),
              this.$api.employeePositions().show(this.employeeUid),
            ])
              .then(([employeeSkill, employee, employeeAward, employeePosition]) => {
                this.employeeSkills = employeeSkill.data 
                this.employee = employee.data
                this.baseLocation = employee.data.city ? employee.data.city.name + ', ' + employee.data.city.state.name : null

                if (employeeAward.data) {
                  this.employeeAwards = employeeAward.data.filter(item => {
                    return this.$moment((item || {}).created_at, 'YYYY-MM-DD').format('YYYY') === this.$moment().format('YYYY')
                  })
                }

                this.position.name = employeePosition.data ? employeePosition.data.position.name : null

                this.loading = false
              })
          }
        },
      },
    },
    methods: {
      showViewer () {
        this.$viewer.show()
      },
      imageViewerInited (viewer) {
        this.$viewer = viewer
      },
      getStatusColor (employee) {
        if (this.isPending(employee)) {
          return 'warning'
        } else if (this.isOnLeave(employee)) {
          return 'info'
        } else {
          return 'success'
        }
      },
      isPending (employee) {
        return employee.joined_date > this.$moment().format('YYYY-MM-DD')
      },
      isOnLeave (employee) {
        return employee.is_active === 0
      },
    
    },
  }
</script>
<style lang="css" scoped>
.v-tooltip__content {
  text-align:left;
}

.position-name-wrap {
    white-space:normal;
    display:table-cell;
    vertical-align:middle;
    font-weight:400;
    font-size:14px
}

.rank-icon{
    width:36px;
    height:36px; 
    border-radius:50%
}

.minimise-gap{
    margin-top: -15px !important;
}

.location-font{
    font-size:14px !important
}

.department-font{
    font-weight: 500 !important;
    font-size:15px !important
}
</style>
